import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { WidgetType } from "clearline-common";
import { AllowedDeliveryChannel, FeatureData } from "../models";

export class FeatureModalBaseComponent {
  title: string;
  data?: FeatureData;
  deliveryMethod: AllowedDeliveryChannel;
  constructor(public activeModal: NgbActiveModal, public featureType: WidgetType) {}

  dismiss() {
    this.activeModal.dismiss();
  }
}
